import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID ,TemplateRef,ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { ThankuResponse } from "../../../shared/payload-Model/billingFormModel";
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { PaymentService } from 'src/app/shared/services/razorpaypayment/payment.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { ModalDismissReasons, NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';

declare const gtag: Function;
declare var $;
function _window(): any {
  return window;
}
@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss']
})
export class OrderConfirmationComponent implements OnInit {

  @ViewChild("vasRPay2", { read: TemplateRef }) vasRPay2!: TemplateRef<any>;
  @ViewChild("content", { read: TemplateRef }) content!: TemplateRef<any>;
  environment1 = environment.s3bucket.url;

  closeResult: string;

  transactionfailed:any =false;
  transactionSuccess:any = false;

  Message: any;
  imageUrl: any;
  HeadMessage: any;
  response: any;
  paymentType:string="";
  baseUrl:any;
  bookingData:any=[];

  sub: Subscription = new Subscription();
  payMessage: any;
  payType:any;
  payData:any;
  apiCount: any = 1;
  loadAPI: Promise<any>;
  vasPaymentSuccess:boolean = false;
  bookingData1:any;
  optyData:any;
  showVasAmt:boolean = false;
  showPopup:boolean = false;
  Dealername:string;
  bookingImage: any;
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private localStorage: secureStorage,
  private cleverService: ClevertapService,private toastrService: ToastrService,

  private behaviorService : BehaviourSubjectService,private regexService: RegexService, private paymentService: PaymentService,

  private apiService: ApiService,private modalService: NgbModal,private spinner: NgxSpinnerService,

    private router: Router, private _activatedRoute: ActivatedRoute) {

    this.modalService.dismissAll();
      this.loadAPI = new Promise((resolve) => {
        this.regexService.loadScript();
        resolve(true);
      });
      _activatedRoute.queryParams.subscribe(
        params =>{
          this.paymentType = params["payment_type"];
        });

  }
  get nativeWindow(): any {
    if (isPlatformBrowser(this.platformId)) {
      return _window();
    }
  }
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {

      localStorage.removeItem('VASData')
      localStorage.removeItem('VASDataProfile')
      this.behaviorService.vasCreated.next(true);
    $('.header').addClass('p-scroll');
      try {
        this.cleverService.onPageView("Order Status Page");
      } catch { }

      window.scrollTo(0, 0);
    }
      this.behaviorService.splitVasPay.subscribe(() => {

  this.transactionfailed =false;
  this.transactionSuccess = false;
    if (isPlatformBrowser(this.platformId)) {
      this.response = JSON.parse(this.localStorage.getItem('Payresponse'));
    }
      if((this.response?.leadInfo?.lead_info?.payment_status == 'Payment Confirmed')
      && (this.response?.leadInfo?.vas_info?.payment_status == 'initialized')
     && (this.response?.leadInfo?.vas_info?.payment_status !== 'Payment Confirmed')){

     }
      this.getleadsData(this.response?.reqId )
      if(this.paymentType == 'cc_avenue'){
        let order_id='';
        let success:string="false";
        this._activatedRoute.queryParams.subscribe(
          params =>{

            order_id = params["order_id"];
            success =  params["success"];
            if(success == "true"){
              this.clevertapPayementcompFailed();
            this.transactionSuccess = true;
              this.Message =  this.response?.payMessage+
              " received against Request ID " +
              this.response?.reqId +
              ".";
              this.response.headMessage = "Thank You !";
              this.HeadMessage = "Thank You !";
              if (isPlatformBrowser(this.platformId)) {
                try {
                  this.baseUrl = window.location.href;
                } catch {}
              }
                gtag("event", "conversion", {
                  send_to: "AW-11093091987/qdJRCLHUzJcYEJPNzKkp",
                  value: this.response?.leadInfo?.vas_info ?
                  Number(this.response?.leadInfo?.vas_info?.vas_payble_amount) + Number(this.response?.leadInfo?.lead_info.final_amount/100)
                  : this.response?.leadInfo?.lead_info.final_amount/100,
                  currency: "INR",
                  transaction_id: this.response.orderId,
                });
              
            }else{
              this.clevertapPayementFailed();
            this.transactionfailed = true;
              this.Message =  this.response?.payMessage+
              " is not received against Request ID " +
              this.response?.reqId +
              "."; this.response.headMessage = "Sorry !";
              this.HeadMessage = "Sorry !";
              const ResponseDatas: PaymentResponse = {} as PaymentResponse;
              ResponseDatas.razorpay_order_id = this.response?.orderId;

      this.sub.add(this.apiService.getPaymentCancelDetail(ResponseDatas).subscribe({
        next: () => {
            if (isPlatformBrowser(this.platformId)) {
              try {

              } catch {}
            }
            }})
      );
            }

            this.response.payMessage = this.Message;
          });
      }else if(this.response) {
if(this.response?.transactionStatus == 'success'){
  this.transactionSuccess = true;

        this.Message = this.response?.payMessage;
        this.imageUrl = this.response?.Image;
        this.HeadMessage = this.response?.headMessage;
        gtag("event", "conversion", {
          send_to: "AW-11093091987/qdJRCLHUzJcYEJPNzKkp",
          value: this.response?.leadInfo?.vas_info ?
          Number(this.response?.leadInfo?.vas_info?.vas_payble_amount) + Number(this.response?.leadInfo?.lead_info.final_amount/100)
          : this.response?.leadInfo?.lead_info.final_amount/100,
          currency: "INR",
          transaction_id: this.response.reqId,
        });
        }else{
          this.transactionfailed = true;
        }
      }
    });



    
  }

payBookingAmt(){
  this.showVasAmt = false;

  let payment_type =  'razorpay';
  let amount = [this.bookingData?.payment_info?.length > 0 ? (this.bookingData?.payment_info?.amount / this.bookingData?.quantity) :
  (this.bookingData?.product?.down_payment)]
      this.paymentService.makePayment(this.bookingData, this.optyData, true, 'booking', null, payment_type, amount);

}
  payVAS(){

    this.showVasAmt = true;
   let VasleadData = this.bookingData.vas_data[0]
   let leadData = this.bookingData;
   let TmlVasPayment = this.bookingData.tml_pay_detail
      this.spinner.show();
       let vas_data = {
        "payment_gateway_type": "RAZORPAY",
        "vas_category": VasleadData?.vas_category,
        "vas_payble_amount": VasleadData?.vas_payble_amount ? Number(VasleadData?.vas_payble_amount) : 0,
        "chassis_number": "",
        "vc_number": VasleadData?.vehicle_number,
        "application": VasleadData?.application,
        "terrian": VasleadData?.terrian,
        "avg_monthly_km": VasleadData?.avg_monthly_km,
        "no_of_years": (VasleadData?.no_of_years).toString(),
        "quantity": VasleadData?.quantity,
        "channel": VasleadData?.channel,
        "fuel_type": VasleadData?.fuel_type,
        "retry_payment": 'True',
        "vas_id": VasleadData?.id,
        "division_id" : this.bookingData.division_id

      }


      if (TmlVasPayment?.length > 1) {
        if (leadData.vas_data?.length > 0) {
          TmlVasPayment.forEach((element: any) => {
            if (element.payment_gt_type == "RAZORPAY" && VasleadData?.id) {
              this.payType = 'RAZORPAY';
              this.payData = element;
              return;
            }else{
              this.payType = 'ccavenue';
              this.payData = element;
            }
          });
        }
      } else {
        if (leadData.vas_data?.length > 0 && TmlVasPayment?.length == 1) {
          TmlVasPayment.forEach((element: any) => {
            if (element.payment_gt_type == "RAZORPAY") {
              this.payType = 'RAZORPAY';
              this.payData = element;
            } else {
              this.payType = 'ccavenue';
              this.payData = element;
              return;
            }
          });
        }else if(TmlVasPayment?.length == 0){
          this.toastrService.error('We are unable to find payment gateway account. Please contact TML on Toll Free Number 1800 209 7979 or cac@tatamotors.com for assistance.');
          return;
        }
      }


      this.payMessage = "Request In Process";

      this.sub.add(this.apiService.generateVasLead(vas_data).subscribe({
        next: (response: any) => {
          if (response.success) {
             this.spinner.hide();
      let razororderDetails = {
        razorpay_account_id: response.data.razorpay_account_id,
        razorpay_access_key:response.data.razorpay_access_key,
        order_id:response.data.payment_order_id,
        pay_amount: response.data.payment_amount,
        product_name: leadData.product.pl,
        product_description: leadData.product.vehicle_number,
        shopping_order_id: response.data.lead_order_or_vas_row_id,
        email: response.data.email_id,
        contact: response.data.mobile_number,
      };

      this.payWithRazor(razororderDetails, leadData.product, response.data);
            this.toastrService.success(response.data.msg);
          }
          else {
            this.spinner.hide();

            this.toastrService.warning(response?.data?.msg)
          }
        },
        error: () => {
          this.toastrService.warning("Something went wrong!")
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        }
      }))
}
  payWithRazor(orderDetails: any, vehicleData: any, leadInfo: any) {

    const ResponseData: PaymentResponse = {} as PaymentResponse;
    const options: any = {
      key: orderDetails.razorpay_access_key,
      amount: orderDetails.pay_amount,
      currency: "INR",
      name: vehicleData.product_name, //'VSS', // company name or product name
      description: vehicleData.product_description, //'Star City Bus',  // product description
      image: `${this.environment1}assets/images/tataMLogo.webp`, // company logo or product image
      order_id: orderDetails.order_id, // order_id created by you in backend
      // account_id: orderDetails.razorpay_account_id,
      prefill: {
        email: orderDetails.email,
        contact: orderDetails.contact,
      },
      modal: {
        escape: false,
      },
      notes: {
        shopping_order_id: orderDetails.shopping_order_id,
      },
      theme: {
        color: "#0c238a",
      },
    };


    options.handler = (response: any) => {
      this.payMessage =
        "Your payment of ₹" +
        ((orderDetails.pay_amount / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) +
        "/- received against Request ID " +
        orderDetails.shopping_order_id +
        ".";
      options.response = response;
      ResponseData.razorpay_payment_id = response.razorpay_payment_id;
      ResponseData.razorpay_order_id = response.razorpay_order_id;
      ResponseData.razorpay_signature = response.razorpay_signature;

      this.sub.add(this.apiService.getPaymentDetail(ResponseData).subscribe({
        next: (response: any) => {

          if (response.success) {
            this.clevertapPayementFailed();
            const objthank: ThankuResponse = {} as ThankuResponse;
            objthank.headMessage = "Thank You !";
            objthank.payMessage = this.payMessage;
            objthank.Image = this.imageUrl;
            objthank.vehicleID = vehicleData["id"];
            objthank.vehicleModel = vehicleData["model"];
            objthank.orderAmount = response["data"].payment_amount / 100
             objthank.leadInfo = leadInfo;

            objthank.orderId = leadInfo?.lead_info.lead_payment_order_id;
            objthank.reqId = leadInfo?.lead_info.row_id;
            objthank.transactionStatus = 'success';

            this.vasPaymentSuccess = true;
if (isPlatformBrowser(this.platformId)) {
            this.localStorage.setItem("Payresponse", JSON.stringify(objthank));
}
            this.behaviorService.splitVasPay.next(true);

            if (isPlatformBrowser(this.platformId)) {
              try {
              } catch { }
          } else {
            this.clevertapPayementFailed();
          }
        }
        }
      }));
    };
    options.modal.ondismiss = () => {
      this.payMessage =
        "Your payment against Request ID " +
        orderDetails.shopping_order_id +
        " of ₹" +

        ((orderDetails.pay_amount / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) +
        "/- is not received.";
      const objthank: ThankuResponse = {} as ThankuResponse;
      objthank.headMessage = "Sorry !";
      objthank.payMessage = this.payMessage;
      objthank.Image = this.imageUrl;
      objthank.vehicleID = vehicleData["id"];
      objthank.leadInfo = leadInfo;
      objthank.orderId = leadInfo?.lead_info.lead_payment_order_id;
      objthank.reqId = leadInfo?.lead_info.row_id;

      objthank.vehicleModel = vehicleData["model"];
      objthank.orderAmount = leadInfo.vas_info.vas_total_amount / 100

      objthank.transactionStatus = 'failure';
if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem("Payresponse", JSON.stringify(objthank));
}
      this.behaviorService.splitVasPay.next(true);

      const ResponseDatas: PaymentResponse = {} as PaymentResponse;
      ResponseDatas.razorpay_order_id = orderDetails.order_id;
      this.sub.add(this.apiService.getPaymentCancelDetail(ResponseDatas).subscribe({
        next: (response: any) => {
          if (isPlatformBrowser(this.platformId)) {
            try {
            } catch { }
          }
        if (isPlatformBrowser(this.platformId)) {
          if (response.success) {
          } else {
          }
        }
        }
      }));
    };
     if (isPlatformBrowser(this.platformId)) {
    const rzp = new this.nativeWindow.Razorpay(options);
    rzp.open();
     }
    return ResponseData;
  }


  getleadsData(reqID: any) {
    this.bookingData = [];

  try {
    this.spinner.show();
    let reqBody = {
      request_id : reqID
    }
    this.sub.add(this.apiService.getLeads(reqBody).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.Dealername=response?.data?.leads[0]?.dealer_info.organization_name;
          this.spinner.hide();
          this.bookingData = response?.data?.leads[0];
          this.bookingImage = response?.data?.leads[0].vehicle_info.image[0].image_url;
          if(this.response?.leadInfo?.vas_info?.vas_payble_amount && this.response?.leadInfo?.vas_info?.payment_status !== 'Payment Confirmed' && this.response?.leadInfo?.vas_info?.vas_payble_amount &&
          this.response?.payment_gateway !== 'CCAVENUE'){
      }


        if((this.bookingData?.payment_status == 'Payment Confirmed')
        && (this.bookingData?.vas_data[0]?.payment_status == 'initialized')
       && (this.bookingData?.vas_data[0]?.payment_status !== 'Payment Confirmed')){

       }
            if(this.bookingData?.vas_data[0]?.payment_status == 'Payment Confirmed'){
            this.vasPaymentSuccess = true;
       this.showPopup = false;


       this.close();
          }
          else{
            this.vasPaymentSuccess = false;

          }
          if(this.bookingData?.payment_info?.type_of_pay_gate && !this.vasPaymentSuccess && this.response?.leadInfo?.vas_info?.vas_payble_amount &&
            this.response?.payment_gateway !== 'CCAVENUE'){

          }
          this.bookingData1 = response.data.leads;


          this.optyData = response?.data;

        if(this.bookingData.vas_data[0].payment_status == "Payment Confirmed"){

        }
      }
        else {
          this.spinner.hide();

          this.bookingData = [];
          this.toastrService.warning(response?.data?.msg)
        }
      },
      error: () => {
        this.toastrService.warning("Something went wrong!")
        this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();

    }
  }))
  } catch (error) {
    this.spinner.hide();
  }
}
ngAfterViewInit() {
  if(this.showPopup){
this.open(this.content)
  }
}
openPopup2(openForm: any) {
  let ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: true,
  };
  this.modalService.open(openForm, ngbModalOptions).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason: any) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}
private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return `with: ${reason}`;
  }
}
close() {
if (isPlatformBrowser(this.platformId)) {
  this.modalService.dismissAll();
}
}
  getTotalAmount(response:any){
if(this.showVasAmt){
  return response?.leadInfo.vas_info.vas_total_amount/100
}else{
  return response?.leadInfo?.vas_info ?
  Number(response?.leadInfo?.vas_info?.vas_payble_amount) + Number(response?.leadInfo?.lead_info.final_amount/100)
  : response?.leadInfo?.lead_info.final_amount/100;
}
  }
getTotalAmount1(response:any){
    return response?.leadInfo?.vas_info ?
    Number(response?.leadInfo?.vas_info?.vas_payble_amount) + Number(response?.leadInfo?.lead_info.final_amount/100)
    : response?.leadInfo?.lead_info.final_amount/100;
  }

  clevertapPayementcompFailed(){
   if (isPlatformBrowser(this.platformId)) {
    try {
     this.cleverService.onPaymentCompleted(
      "Success",
      "Online Transfer",
      this.response?.leadInfo?.lead_info['id'],
      this.response?.leadInfo?.lead_info["model"],
      this.response?.leadInfo?.cover_image ? this.response?.leadInfo?.cover_image  : 'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/default/tata_trucks.jpg',
      "Top Navigation",
      this.response?.leadInfo.sub_lob,
      this.response?.leadInfo?.lead_info['lob'],
      this.response?.leadInfo?.lead_info['ppl'],
      this.response?.leadInfo.ex_showroom_amount,
      this.response?.leadInfo.booking_amount,
      this.response?.leadInfo.payment_amount/10,
     );
    } catch {}
   }
  }


  clevertapPayementFailed(){

   if (isPlatformBrowser(this.platformId)) {
    try {
     this.cleverService.onPaymentfailed(
      this.response?.leadInfo.id,
      "Online Transfer",
      this.response?.leadInfo?.cover_image ? this.response?.leadInfo?.cover_image  : 'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/default/tata_trucks.jpg',

      this.response?.leadInfo?.lead_info["model"],
      "Top Navigation",
      this.response?.leadInfo.sub_lob,
      this.response?.leadInfo?.lead_info['lob'],
      this.response?.leadInfo?.lead_info['ppl'],
      this.response?.leadInfo?.ex_showroom_amount,
      this.response?.leadInfo?.booking_amount,
      this.response?.leadInfo?.payment_amount/10,
     );
    } catch {}
   }
  }



  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('VASDataProfile')

    this.sub.unsubscribe();

    }
  }

open(content) {
  this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
    (result) => {
      this.closeResult = `Closed with: ${result}`;
    },
    (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason1(reason)}`;
    },
  );
}

private getDismissReason1(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return `with: ${reason}`;
  }
}
gotoBooking(){
  this.router.navigate(['/account/booking'])
}
}
export class PaymentResponse {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
}



